module.exports = "/_next/static/images/next_investments-474a2952ad8d758956ca394c90c19090.jpeg";